// src/app/global-error.tsx
//
// Next.js標準の「最後の砦」エラーバウンダリ。ルートレイアウトを含め、
// どこにもキャッチされなかったエラーがここに来る。
//
// 2026-07-19追加：白画面インシデント（Application error）が起きたとき、
// window.onerror（src/lib/crashDiagnostics.ts）では検知できないケースが
// あることが判明した（Next.jsの内部エラーバウンダリが先に捕まえてしまい、
// window.onerrorまで届かない）。ここで直接エラー内容とコミット比較結果を
// 画面に表示することで、コンソールを開かなくてもスクリーンショット一枚で
// 診断できるようにする。
//
// 既存ロジックには一切干渉しない（このファイルはエラー発生時のみ表示される）。

"use client";

import { useEffect, useState } from "react";
import { diagnoseCommitMismatch, type CommitDiagnosis } from "@/lib/crashDiagnostics";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const [diag, setDiag] = useState<CommitDiagnosis | null>(null);

  useEffect(() => {
    console.error("[global-error] キャッチしたエラー:", error);

    diagnoseCommitMismatch().then((result) => {
      setDiag(result);
      console.error("[crash-diagnostics] コミット比較（global-error経由）", {
        errorMessage: error?.message,
        ...result,
        time: new Date().toISOString(),
      });
    });
  }, [error]);

  return (
    <html lang="ja">
      <body style={{ fontFamily: "sans-serif", padding: 24, background: "#fafafa", color: "#222" }}>
        <h1 style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>
          エラーが発生しました
        </h1>
        <p style={{ marginBottom: 16, fontSize: 14, lineHeight: 1.6 }}>
          お手数ですが、下の内容をスクリーンショットで残してから「再読み込み」を押してください。
        </p>
        <pre
          style={{
            background: "#fff",
            border: "1px solid #ddd",
            borderRadius: 8,
            padding: 12,
            fontSize: 12,
            whiteSpace: "pre-wrap",
            wordBreak: "break-all",
            marginBottom: 16,
          }}
        >
{`message: ${error?.message ?? "unknown"}
myCommit: ${diag?.myCommit ?? "取得中…"}
liveCommit: ${diag?.liveCommit ?? "取得中…"}
status: ${diag?.status ?? "取得中…"}
判定: ${diag?.判定 ?? "取得中…"}`}
        </pre>
        <button
          onClick={() => reset()}
          style={{
            padding: "10px 20px",
            background: "#111",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            fontSize: 14,
            cursor: "pointer",
          }}
        >
          再読み込み
        </button>
      </body>
    </html>
  );
}
